import { StylesConfig } from 'react-select';
import { OptionType } from 'components/CustomSelect/types';

const multipleTypeApproachListStyles: StylesConfig<OptionType, false> = {
  option: styles => ({
    ...styles,
    padding: '6.8px 12px',
  }),
};

export default multipleTypeApproachListStyles;
